// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rebate-total[data-v-dab3f9d4] {\n  text-align: right;\n  float: right;\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
